
import React from 'react';

const ButtonRejectOrder = ({ setRejected, isDisabled = false }) => (
  <button className="btn btn-error btn-md2 mb15 ml10" type="button" disabled={isDisabled} onClick={setRejected}>Reject</button>
);

export default ButtonRejectOrder;
